// 在线词条维护服务白名单
export const i18nWhiteList = [
    '127.0.0.1',
    'localhost',
    '192.168.136.68',
    '192.168.160.243',
    '192.168.154.164',
    '192.168.154.137',
    '192.168.1.65',
    '192.168.1.35',
];  

// 词条在线服务地址
export const i18nServer = 'http://192.168.1.19:7200/platform/bdo-merchant';

export const onlineServiceOn = false // i18nWhiteList.includes(window.location.hostname);

// BDO管理平台生产地址
export const BDOCHECKOUTURL = "https://www.bdocheckout.bdo.com.ph/";

// BDO管理平台UAT地址
export const BDOCHECKOUTUATURL = "https://bdo-uat.wallyt.net/";
